const orderApprovePageMainForm = {
  model: null,
  rules: {
    current: null,
    // 修改订单时的验证规则 - 暂时不做验证
    modify: {
      orderProppserInfo: {
        proppserName: {required: true, message: '必填', trigger: 'blur'},
        sex: {required: true, message: '必填', trigger: 'blur'},
        idType: {required: true, message: '必填', trigger: 'blur'},
        idno: {required: true, message: '必填', trigger: 'blur'},
        birth: {required: true, message: '必填', trigger: 'blur'},
        marriage: {required: true, message: '必填', trigger: 'blur'},
        education: {required: true, message: '必填', trigger: 'blur'},
        mobile: {required: true, message: '必填', trigger: 'blur'}
      }
    },
    // 车辆估值时的验证规则
    evaluationPrice: {
      orderCarInfo: {
        vinIdentifyChe300: [{required: true, message: '必填，请先调用车300识别', trigger: 'blur'}],
        transferCnt: [{required: true, message: '必填', trigger: 'blur'}],
        carColor: [{required: true, message: '必填，请选择颜色', trigger: 'blur'}],
        carMiles: [{required: true, message: '必填', trigger: 'blur'}],
        aCarCondtion: [{required: true, message: '必填，请选择车况', trigger: 'blur'}],
        carFirstBook: [{required: true, message: '必填，请选择日期', trigger: 'blur'}]
      }
    }
  }
}

export {
  orderApprovePageMainForm
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.form.main.js